"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckMark = function CheckMark() {
  return _react2.default.createElement(
    "svg",
    { width: "19px", height: "14px", viewBox: "0 0 19 14" },
    _react2.default.createElement("path", {
      d: "M166.300269,1690.60396 C166.843595,1691.13201 167.708414, 1691.13201 168.251741,1690.60396 L179.775736, 1679.40396 C180.330209,1678.86508 180.342847, 1677.97874 179.803963,1677.42427 C179.265079, 1676.86979 178.378738,1676.85715 177.824265, 1677.39604 L166.300269,1688.59604 L168.251741, 1688.59604 L164.375737,1684.82901 C163.821264, 1684.29012 162.934923,1684.30276 162.396039, 1684.85723 C161.857155,1685.41171 161.869792, 1686.29805 162.424265,1686.83693 L166.300269,1690.60396 Z",
      transform: "translate(-162.000000, -1677.000000)",
      fill: "#FFFFFF"
    })
  );
};

exports.default = CheckMark;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/Button/CheckMark.js
// module id = 268
// module chunks = 0